module.exports = __webpack_public_path__ + "img/premium_02.e505ced5.png";